const initialState = {
    apps: {}
}

const guidanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GUIDE_START': {
            const { appId, totalSteps, version } = action.payload
            const app = state.apps[appId] || {}
            return {
                ...state,
                apps: {
                    ...state.apps,
                    [appId]: {
                        ...app,
                        seen: app.seen || false,
                        completed: app.completed || false,
                        currentStep: typeof app.currentStep === 'number' ? app.currentStep : 0,
                        totalSteps,
                        version: app.version || version || '1'
                    }
                }
            }
        }
        case 'GUIDE_SEEN': {
            const { appId, version } = action.payload
            const app = state.apps[appId] || {}
            return {
                ...state,
                apps: {
                    ...state.apps,
                    [appId]: { ...app, seen: true, version: version || app.version || '1' }
                }
            }
        }
        case 'GUIDE_SET_STEP': {
            const { appId, step } = action.payload
            const app = state.apps[appId] || {}
            return {
                ...state,
                apps: {
                    ...state.apps,
                    [appId]: { ...app, currentStep: step }
                }
            }
        }
        case 'GUIDE_COMPLETE': {
            const { appId, version } = action.payload
            const app = state.apps[appId] || {}
            return {
                ...state,
                apps: {
                    ...state.apps,
                    [appId]: { ...app, completed: true, version: version || app.version || '1' }
                }
            }
        }
        case 'GUIDE_RESET': {
            const { appId } = action.payload
            const app = state.apps[appId] || {}
            return {
                ...state,
                apps: {
                    ...state.apps,
                    [appId]: { ...app, currentStep: 0, completed: false }
                }
            }
        }
        default:
            return state
    }
}

export default guidanceReducer

